"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/stable/object/assign");
require("core-js/stable/promise");
require("core-js/modules/es.map");
var Chobitsu_1 = __importDefault(require("./Chobitsu"));
var noop_1 = __importDefault(require("licia/noop"));
var Runtime = __importStar(require("./domains/Runtime"));
var Page = __importStar(require("./domains/Page"));
var DOM = __importStar(require("./domains/DOM"));
var CSS = __importStar(require("./domains/CSS"));
var DOMStorage = __importStar(require("./domains/DOMStorage"));
var Network = __importStar(require("./domains/Network"));
var Overlay = __importStar(require("./domains/Overlay"));
var DOMDebugger = __importStar(require("./domains/DOMDebugger"));
var Debugger = __importStar(require("./domains/Debugger"));
var Storage = __importStar(require("./domains/Storage"));
var CacheStorage = __importStar(require("./domains/CacheStorage"));
var IndexedDB = __importStar(require("./domains/IndexedDB"));
var Input = __importStar(require("./domains/Input"));
var chobitsu = new Chobitsu_1.default();
chobitsu.register('Network', __assign(__assign({}, Network), { setAttachDebugStack: noop_1.default, clearAcceptedEncodingsOverride: noop_1.default }));
chobitsu.register('Page', __assign(__assign({}, Page), { getManifestIcons: noop_1.default, bringToFront: noop_1.default, getInstallabilityErrors: noop_1.default, setAdBlockingEnabled: noop_1.default, getAppId: noop_1.default }));
chobitsu.register('Runtime', __assign(__assign({}, Runtime), { getExceptionDetails: noop_1.default, compileScript: noop_1.default, discardConsoleEntries: noop_1.default, getHeapUsage: noop_1.default, getIsolateId: noop_1.default, releaseObject: noop_1.default, releaseObjectGroup: noop_1.default, runIfWaitingForDebugger: noop_1.default }));
chobitsu.register('DOM', __assign(__assign({}, DOM), { pushNodeByPathToFrontend: noop_1.default, getNodeId: DOM.getDOMNodeId, getNode: DOM.getDOMNode, markUndoableState: noop_1.default, undo: noop_1.default, getBoxModel: noop_1.default }));
chobitsu.register('CSS', __assign(__assign({}, CSS), { getPlatformFontsForNode: noop_1.default, trackComputedStyleUpdates: noop_1.default, takeComputedStyleUpdates: noop_1.default }));
chobitsu.register('Debugger', __assign(__assign({}, Debugger), { getPossibleBreakpoints: noop_1.default, setBreakpointByUrl: noop_1.default, setBreakpointsActive: noop_1.default, setAsyncCallStackDepth: noop_1.default, setBlackboxPatterns: noop_1.default, setPauseOnExceptions: noop_1.default }));
chobitsu.register('Overlay', __assign(__assign({}, Overlay), { setPausedInDebuggerMessage: noop_1.default, highlightFrame: noop_1.default, setShowGridOverlays: noop_1.default, setShowFlexOverlays: noop_1.default, setShowScrollSnapOverlays: noop_1.default, setShowContainerQueryOverlays: noop_1.default, setShowIsolatedElements: noop_1.default }));
chobitsu.register('Profiler', {
    enable: noop_1.default,
});
chobitsu.register('Log', {
    clear: noop_1.default,
    enable: noop_1.default,
    startViolationsReport: noop_1.default,
});
chobitsu.register('Emulation', {
    setEmulatedMedia: noop_1.default,
    setAutoDarkModeOverride: noop_1.default,
    setEmulatedVisionDeficiency: noop_1.default,
    setFocusEmulationEnabled: noop_1.default,
    setTouchEmulationEnabled: noop_1.default,
    setEmitTouchEventsForMouse: noop_1.default,
});
chobitsu.register('Audits', {
    enable: noop_1.default,
});
chobitsu.register('ServiceWorker', {
    enable: noop_1.default,
});
chobitsu.register('Inspector', {
    enable: noop_1.default,
});
chobitsu.register('Target', {
    setAutoAttach: noop_1.default,
    setDiscoverTargets: noop_1.default,
    setRemoteLocations: noop_1.default,
});
chobitsu.register('DOMDebugger', __assign(__assign({}, DOMDebugger), { setBreakOnCSPViolation: noop_1.default }));
chobitsu.register('Database', {
    enable: noop_1.default,
});
chobitsu.register('CacheStorage', __assign({}, CacheStorage));
chobitsu.register('Storage', __assign(__assign({}, Storage), { setInterestGroupTracking: noop_1.default, setSharedStorageTracking: noop_1.default, trackIndexedDBForStorageKey: noop_1.default, untrackCacheStorageForOrigin: noop_1.default, untrackIndexedDBForOrigin: noop_1.default, trackCacheStorageForOrigin: noop_1.default, trackIndexedDBForOrigin: noop_1.default }));
chobitsu.register('DOMStorage', __assign({}, DOMStorage));
chobitsu.register('IndexedDB', __assign({ enable: noop_1.default }, IndexedDB));
chobitsu.register('ApplicationCache', {
    enable: noop_1.default,
    getFramesWithManifests: noop_1.default,
});
chobitsu.register('BackgroundService', {
    startObserving: noop_1.default,
});
chobitsu.register('HeapProfiler', {
    enable: noop_1.default,
});
chobitsu.register('Input', __assign({}, Input));
chobitsu.register('Autofill', {
    enable: noop_1.default,
});
exports.default = chobitsu;
